if (!customElements.get('product-specs')) {
  customElements.define(
    'product-specs',
    class ProductSpecs extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('.product-specs__toggle');
        if (!this.toggle) return;
        this.text = this.toggle.querySelector('.product-specs__toggle-text');
        this.toggle.addEventListener('click', () => this.onToggle());
      }

      onToggle() {
        const collapsed = this.dataset.collapsed !== 'false';
        this.dataset.collapsed = collapsed ? 'false' : 'true';
        this.toggle.setAttribute('aria-expanded', collapsed ? 'true' : 'false');
        if (this.text) {
          this.text.textContent = collapsed ? this.toggle.dataset.less : this.toggle.dataset.more;
        }
      }
    }
  );
}
